"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createRelayedDispatch = exports.relayChannelClientApi = void 0;
const EXPECTED_ERRORS = [
    'no longer connected',
    'RTCDataChannel closed unexpectedly',
    'The client you are trying to dispatch from is disconnected from the target provider',
];
// Checks possible error messages that we want to trap, client error message can originate
// from ChannelProvider::dispatch OR ClassicStrategy::closeEndpoint OR RTCEndPoint::dataChannel::onclose
const isDisconnectedError = (errorMsg) => {
    return EXPECTED_ERRORS.some(e => errorMsg.includes(e));
};
/**
 * @internal
 * Create a channel relay for a given channel exposition, allowing a single provider to route
 * actions to the designated clients.
 *
 * Designed to be used in conjunction with @expose
 *
 * @param channelProvider The channel provider to relay the actions on.
 * @param config Determines which actions to relay. Please ensure action prefix matches the exposed api.
 */
const relayChannelClientApi = async (channelProvider, relayId) => {
    channelProvider.register(`relay:${relayId}`, ({ action, target, payload }) => {
        return channelProvider.dispatch(target, action, payload);
    });
    await Promise.resolve();
};
exports.relayChannelClientApi = relayChannelClientApi;
const createRelayedDispatch = (client, target, relayId, relayErrorMsg) => async (action, payload) => {
    try {
        return await client.dispatch(`relay:${relayId}`, {
            action,
            payload,
            target
        });
    }
    catch (e) {
        if (isDisconnectedError(e.message) && relayErrorMsg) {
            throw new Error(relayErrorMsg);
        }
        ;
        throw e;
    }
};
exports.createRelayedDispatch = createRelayedDispatch;
